import { Button } from '@material-ui/core'
import { CloudDownload } from '@material-ui/icons'
import React from 'react'
import { Identifier, useNotify } from 'react-admin'
import { apiUrl } from '../../AppDataProvider'

import httpClient from '../../CustomHttpClient'

const DownloadReceiptButton = (props: { id: Identifier | undefined }) => {
  const notify = useNotify()

  const downloadReceipt = async () => {
    const url = `${apiUrl}/payout-settlement/${props.id}/download/receipt`
    httpClient(url, {
      method: 'get',
    })
      .then((res) => {
        const imageLink = res.json.signedUrl
        window.open(imageLink, '_blank')
        notify('Comprovante baixado com sucesso!')
      })
      .catch((e) => {
        console.error(e)
        notify('Erro ao baixar comprovante!')
      })
  }

  return (
    <div>
      <Button
        data-testid={`upload-button`}
        color="secondary"
        size="medium"
        variant="outlined"
        startIcon={<CloudDownload />}
        onClick={(e) => {
          e.stopPropagation()
          downloadReceipt()
        }}
      >
        Baixar Comprovante
      </Button>
    </div>
  )
}

export default DownloadReceiptButton
